<!--
__________________________________________________
Summary 
‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾
Vue component for switching accounts.

General usage of this component will not need to specify inline properties on the component. 
All use cases will involve directly invoking switchAccount 

__________________________________________________
Methods
‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾

showAccounts()
Opens the switch accounts dialog 
__________________________________________________
Usage
‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾
Register the switchAccounts component in the template entry-point of your application, including 'ref="switchAccounts"': 
<SwtichAccounts ref="switchAccounts" />

From javascript within any Vue components, you can reference the showAccounts method via the $root.$refs.switchAccounts handle. 
Example:

  // show a message dialog
  $root.$refs.switchAccounts.showAccounts();

-->

<template>
  <div id="divSwitch" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="myModalLabel">Switch Account</h4>
          <button type="button" class="close" data-dismiss="modal" v-on:click="processClose()"aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="accountList" class="form-label">&nbsp;Choose Account</label><br/>
              <select id="accountList" 
                @dblclick="doSwitch()"
                @keyup.enter="doSwitch()"
                v-model="newAccountId"
                class="custom-select"
                size="10"
              >
                <option v-for="account in accounts" 
                  :value="account.id"
                >{{account.account_name}}</option>
              </select>
            </div>
        </div>
        <div class="modal-footer">

          <button type="button" class="btn btn-light"
            data-dismiss="modal">Cancel</button>
          <button v-on:click="doSwitch()" type="button" class="btn btn-primary"
            data-dismiss="modal" :disabled="activeAccount.id == newAccountId">Switch</button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  computed: {
    ...mapState({
      uiConfig: (state)=>{
        if (state.admin ) return state.admin.uiConfig;
        else return state.user.uiConfig;
      },
      accounts: (state)=>{
        if (state.admin ) return state.admin.accounts;
        else return state.user.uiConfig.accounts;
      },
      adminState: (state)=>{
        return Boolean(state.admin)
      },
      activeAccount: (state)=>{
        if (state.admin ) {
          return state.admin.currentAccount
        } else if (state.user.uiConfig.account && state.user.uiConfig.account.id!=null) {
          return state.user.uiConfig.account;
        } else {
          return {}
        }

      }
    }),
    /*activeAccount: function() {
      if (this.uiConfig.account && this.uiConfig.account.id!=null) {
        return this.uiConfig.account;
      } else {
        return {};
      }
    }*/
  },
  data: function () {
    return {
      newAccountId: null
    }
  },
  mounted: function() {
    let that = this;
    $('#divSwitch').on('shown.bs.modal', function () {
      $('#accountList').focus()
    })
  },
  methods: {
    showAccounts: function(options) {
      this.newAccountId = this.activeAccount.id;
      $('#divSwitch').modal('show');
      /*setTimeout(()=>{
        $(`#accountList`).focus();
      },250);*/
    },
    doSwitch: function() {
      window.location.href = "/api/v1/change-account/" + this.newAccountId; 
    },
    processClose(){
      
    },
  },
}
</script>

<style scoped>
#divSwitch.modal.fade {
  z-index: 100000 !important;
}
</style>